"use client";

export const isSafari13OrLower = () => {
  const ua = navigator.userAgent;
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  if (isSafari) {
    const match = ua.match(/Version\/(\d+)/);
    if (match && parseInt(match[1], 10) <= 13) {
      return true;
    }
  }
  return false;
};
